import { Component, OnInit, Inject, PLATFORM_ID, TransferState, makeStateKey } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { EditorialApiService } from '@modules/editorial/editorial-api.service';
import { SeoMetadataService } from '@shared/services/seo-metadata.service';
import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { tap } from 'rxjs';

const EDITORIAL_KEY = makeStateKey<any>('EDITORIAL');

@Component({
  selector: 'astrea-editorial',
  templateUrl: './editorial.component.html',
  styleUrls: ['./editorial.component.scss']
})
export class EditorialComponent implements OnInit {

  public url!: string | null;
  public editorial!: any;
  public books!: any;
  public loading = true;
  public totalLength!: number;
  public itemsPerPage: number = 16;
  public filters = {
    limit: this.itemsPerPage,
    offset: 0
  };

  public firstLoad = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: EditorialApiService,
    private seo: SeoMetadataService,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    this.url = this.route.snapshot.paramMap.get('url');
    if (!this.url) {
      this.router.navigate(['/home']);
      return;
    }

    const page = this.route.snapshot.queryParams['page'];
    this.filters.offset = page ? (parseInt(page) - 1) * this.itemsPerPage : 0;
    this.loadEditorials();

    this.route.queryParams
      .subscribe({
        next: (params: Params) => {
          if (isPlatformBrowser(this.platformId)) {
            this.filters.offset = params.page ? (parseInt(params.page) - 1) * this.itemsPerPage : 0;
            if (this.firstLoad) {
              this.firstLoad = false;
              return;
            }
            this.loadEditorials();
          }
        }
      });
  }

  setMetadata(): void {
    if (this.editorial) {
      this.seo.setMetadata({
        title: `Editorial ${this.editorial.editorial}`,
        description: `Obras de la editorial ${this.editorial.editorial}.`,
        relativeUrl: `/editorial/${this.url}`
      });
    }
  }

  loadEditorials(): void {
    const cachedData = this.transferState.get(EDITORIAL_KEY, null);
    if (cachedData) {
      this.editorial = cachedData.result.data;
      this.books = cachedData.result.data.vDoctrines;
      this.totalLength = cachedData.result.data.sizeDoctrines;
      this.loading = false;
      this.setMetadata();
      this.transferState.remove(EDITORIAL_KEY);
    } else {
      this.getBooks();
    }
  }

  getBooks(): void {
    this.loading = true;
    this.api.getBooks(this.url, this.filters)
      .pipe(
        tap(data => {
          if (isPlatformServer(this.platformId)) {
            this.transferState.set(EDITORIAL_KEY, data);
          }
        })
      )
      .subscribe({
        next: res => {
          this.editorial = res.result.data;
          this.books = res.result.data.vDoctrines;
          this.totalLength = res.result.data.sizeDoctrines;
          this.loading = false;
          this.setMetadata();
        },
        error: () => {
          this.router.navigate(['/home']);
        }
      });
  }
}
